import { Container, rem, useMantineTheme } from '@mantine/core';
import type { PropsWithChildren } from 'react';

export type SimpleLayoutProps = PropsWithChildren<{
	fluid?: boolean;
}>;

export function SimpleLayout({ fluid, children }: SimpleLayoutProps) {
	const theme = useMantineTheme();

	return (
		<Container fluid={fluid} size='xl' pt='xs' pb='xl' mt={rem(theme.other.headerHeight)}>
			{children}
		</Container>
	);
}
